// config.selectors.ts
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ComponentConfigState } from './component-config.reducer';

// Feature selector for the config state
export const selectComponentConfigState =
  createFeatureSelector<ComponentConfigState>('componentConfig');

// Selector for the configuration data

export const selectComponentConfigLoaded = createSelector(
  selectComponentConfigState,
  (state: ComponentConfigState) => state.loaded
);

export const selectComponentConfig = createSelector(
  selectComponentConfigState,
  (state: ComponentConfigState) => state.config
);

// Selector for the error
export const selectComponentConfigError = createSelector(
  selectComponentConfigState,
  (state: ComponentConfigState) => state.error
);
